import raw from "./articles.json";

export type ArticleNiche = "saldo-retido" | "multipropriedade" | "vazamento-dados" | "falso-chargeback" | "desocupacao-temporada";

export interface ArticleFAQ {
  question: string;
  answer: string;
}

export interface Article {
  slug: string;
  niche: ArticleNiche;
  nicheLabel: string;
  nicheUrl: string;
  title: string;
  subtitle: string;
  targetEntity: string;
  readingTime: string;
  publishedAt: string;
  legalSummary: string;
  contentHtml: string;
  faqs: ArticleFAQ[];
  ctaPrice: string;
  metaTitle?: string;
  metaDescription?: string;
}

export const ARTICLE_NICHES: readonly ArticleNiche[] = ["saldo-retido", "multipropriedade", "vazamento-dados", "falso-chargeback", "desocupacao-temporada"];

const STRING_KEYS = ["slug", "nicheLabel", "nicheUrl", "title", "subtitle", "targetEntity", "readingTime", "publishedAt", "legalSummary", "contentHtml", "ctaPrice"] as const;

const isRecord = (v: unknown): v is Record<string, unknown> => typeof v === "object" && v !== null;

export const isArticleNiche = (v: unknown): v is ArticleNiche => typeof v === "string" && (ARTICLE_NICHES as readonly string[]).includes(v);

const isFaq = (v: unknown): v is ArticleFAQ => isRecord(v) && typeof v.question === "string" && typeof v.answer === "string";

const OPTIONAL_STRING_KEYS = ["metaTitle", "metaDescription"] as const;

export function isArticle(v: unknown): v is Article {
  return (
    isRecord(v) &&
    STRING_KEYS.every((k) => typeof v[k] === "string") &&
    OPTIONAL_STRING_KEYS.every((k) => v[k] === undefined || (typeof v[k] === "string" && (v[k] as string).trim().length > 0)) &&
    isArticleNiche(v.niche) &&
    Array.isArray(v.faqs) &&
    v.faqs.every(isFaq)
  );
}

function parseArticles(data: unknown): Article[] {
  if (!Array.isArray(data)) throw new Error("articles.json inválido: esperado um array");
  return data.map((item, i) => {
    if (!isArticle(item)) throw new Error(`articles.json inválido no índice ${i}`);
    return item;
  });
}

export const articles: Article[] = parseArticles(raw);

export const getArticle = (niche: string, slug: string): Article | undefined =>
  articles.find((a) => a.niche === niche && a.slug === slug);

export const getArticlesByNiche = (niche: ArticleNiche): Article[] => articles.filter((a) => a.niche === niche);
